import React, {Dispatch, FC, SetStateAction} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {ITodayBroadcast} from './core/_model'

type Props = {
  setSingleBroadcast: Dispatch<SetStateAction<ITodayBroadcast | undefined>>
  broadcast: ITodayBroadcast
}

const TodayBroadCastAction: FC<Props> = ({setSingleBroadcast, broadcast}) => {
  return (
    <div>
      <button
        type='button'
        className='btn btn-light-primary btn-sm'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_1'
        onClick={() => {
          setSingleBroadcast(broadcast)
        }}
      >
        {/* <KTIcon iconName='filter' className='fs-2' /> */}
        View
      </button>
    </div>
  )
}

export default TodayBroadCastAction
